import React from 'react';
import './CollectionHeader.css';
import CollectionSummary from '../CollectionSummary/CollectionSummary';

interface CollectionStats {
  haveListCount: number;
  haveListValue: number;
  wantListCount: number;
  wantListValue: number;
}

interface Props {
  stats: CollectionStats;
}

export default function CollectionHeader({ stats }: Props) {
  return (
    <div className="collection-header-container">
      <div className="collection-header">
        <h2 className="collection-title">My Collection</h2>
        <p className="collection-subtitle">
          Manage your cards and track your collection value.
        </p>
      </div>
      <CollectionSummary stats={stats} />
    </div>
  );
}